'use client'
import React from 'react';
import BlogCardHome from '@components/BlogCardHome';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import LinkComponent from '@components/LinkComponent';
import 'swiper/css';
import 'swiper/css/navigation';

const BlogCardSlider = ({ title, description, blogs, moreUrl = '', dictionary, lang, params }) => {
    return (
    <div className='w-full'>
        <div className='2xl:w-10/12 max-w-[1600px] mx-auto flex flex-col my-4 pl-2 md:pl-0'>
            <h1 className='text-maincolor text-2xl font-bold'>{title}</h1>
            <p className='text-maincolor text-xl mb-2'>{description}</p>
            {blogs.length > 0 && (
                <div className='sm:block hidden'>
                    <Swiper
                        // slidesPerView={'auto'}
                        spaceBetween={10}
                        slidesPerView={4}
                        pagination={{
                            clickable: true,
                        }}
                        navigation={true}
                        modules={[Navigation]}
                        className=''
                    >
                        {blogs.map((blog, index) => (
                            <SwiperSlide key={index}>
                                <BlogCardHome blog={blog} dictionary={dictionary} lang={lang} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )}
            {blogs.length > 0 && (
                <div className='sm:hidden block'>
                    <Swiper
                        spaceBetween={10}
                        slidesPerView={1.5}
                    >
                        {blogs.map((blog, index) => (
                            <SwiperSlide key={index}>
                                <BlogCardHome blog={blog} dictionary={dictionary} lang={lang} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )}
            {blogs?.length > 0 && moreUrl !== '' && (
                <div className='w-full flex justify-center mb-2 mt-4'>
                    <LinkComponent className='w-[300px] bg-maincolor text-xl text-light text-center rounded-md py-2' href={moreUrl}>{dictionary.section.seeMore}</LinkComponent>
                </div>
            )}
        </div>
    </div>
  )
}

export default BlogCardSlider